<template>
  <v-dialog
    v-model="showDialog"
    max-width="500"
    scrollable
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-bind="$attrs"
        block
        outlined
        color="primary"
        class="mb-4"
        data-cy="btn_desistir_reembolso"
        :disabled="disableBtn"
        v-on="on"
      >
        Desistir
      </v-btn>
    </template>
    <v-card data-cy="modal_desistir_reembolso">
      <v-card-title
        class="title pt-5 pb-0"
        primary-title
        data-cy="modal_titulo_desistir_reembolso"
      >
        Desistir do reembolso
      </v-card-title>

      <v-card-text
        class="pt-2 pb-9"
        data-cy="modal_texto_desistir_reembolso"
      >
        <p class="mb-0">
          <slot name="texto" />
        </p>
      </v-card-text>

      <v-card-actions class="pt-9">
        <v-spacer />
        <v-btn
          color="primary"
          text
          data-cy="modal_btn_nao_desistir_reembolso"
          @click="showDialog = false"
        >
          Não
        </v-btn>

        <v-btn
          color="primary"
          text
          data-cy="modal_btn_sim_desistir_reembolso"
          :loading="loading"
          @click="cancelarReembolso()"
        >
          Sim
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api';

export default {
  name: 'ModalDesistir',

  props: {
    statusReembolso: {
      type: String,
      required: true,
    },

    codigoReembolso: {
      type: Number,
      required: true,
    },

    codigoVenda: {
      type: Number,
      required: true,
    },

    disableBtn: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      showDialog: false,
      loading: false,
    };
  },

  methods: {
    async cancelarReembolso() {
      let sucesso = true;
      this.loading = true;

      try {
        await api.put(`/refund-request/close/${this.codigoReembolso}`, {
          order: this.codigoVenda,
        });
      } catch (error) {
        sucesso = false;
      }

      this.loading = false;

      this.$emit('repostaApi', sucesso);
      this.showDialog = false;
    },
  },
};
</script>
